import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  margin-top: ", "px;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n  line-height: ", "px;\n  margin-right: ", "px;\n  margin-top: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  margin-top: ", "px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled from 'styled-components';
import { gridSize } from '@atlaskit/theme/constants';
import { multiply } from '@atlaskit/theme/math';
import { h600 } from '@atlaskit/theme/typography';
/**
 * Provide a styled container for form sections.
 */

var FormSectionWrapper = styled.div(_templateObject(), multiply(gridSize, 3));
/**
 * Provide a styled container for form section title
 */

var FormSectionTitle = styled.h3(_templateObject2(), h600, multiply(gridSize, 4), multiply(gridSize, 4));
/**
 * Provide a styled container for form section content.
 */

var FormSectionDescription = styled.div(_templateObject3(), gridSize);
export default FormSectionWrapper;
export { FormSectionTitle, FormSectionDescription };